const API_BASE = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  return localStorage.getItem('cs_token');
}

async function request(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: 'Unknown error' }));
    throw { status: res.status, detail: err.detail || 'Error' };
  }

  return res.json();
}

export const api = {
  // Auth
  login: (email, password, totpCode = null) =>
    request('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password, ...(totpCode ? { totp_code: totpCode } : {}) }),
    }),

  register: (name, email, password) =>
    request('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ name, email, password }),
    }),

  me: () => request('/auth/me'),

  forgotPassword: (email) =>
    request('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  // Generic methods for admin
  get:  (path)       => request(path),
  post: (path, body) => request(path, { method: 'POST',   body: body ? JSON.stringify(body) : undefined }),
  put:  (path, body) => request(path, { method: 'PUT',    body: body ? JSON.stringify(body) : undefined }),
  del:  (path)       => request(path, { method: 'DELETE' }),
};
